import * as types from "./mutation_types";

const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const del = ({ commit }, id) => {
  commit(types.LINK_DELETE_TOGGLE_LOADING);
  axios
    .delete(URL_BACKEND + "api-rob/removeLink/" + id + "/")
    .then(() => {
      commit(types.LINK_DELETE_TOGGLE_LOADING);
    })
    .catch(() => {
      commit(types.LINK_DELETE_TOGGLE_LOADING);
    });
};
